import { addDays } from 'date-fns'
import { observer } from 'mobx-react'
import { FC } from 'react'

import {
  ButtonGroup,
  DatePickerField,
  formatDate,
  HorizontalAlignment,
} from '@avantstay/backoffice-core'

import { FiltersProps } from '@new/domains/operations/screens/CasesV2/CasesV2.types'
import { casesFiltersStore } from '@new/domains/operations/screens/CasesV2/stores/CasesFiltersStore'

import { CalendarContainer, CustomFilterDate } from './DateFilter.styles'

interface CreatedAtFilterProps extends FiltersProps {
  initialValue?: string
  onChange: (value?: string) => void
}

enum CreatedAtFilterTypes {
  lastDay = 'lastDay',
  lastWeek = 'lastWeek',
  lastMonth = 'lastMonth',
  today = 'today',
}

const calendarOptions = [
  {
    id: CreatedAtFilterTypes.today,
    value: `${formatDate(new Date())}_${formatDate(new Date())}`,
    title: 'Today',
  },
  {
    id: CreatedAtFilterTypes.lastDay,
    value: `${formatDate(addDays(new Date(), -1))}_${formatDate(new Date())}`,
    title: 'Last Day',
  },
  {
    id: CreatedAtFilterTypes.lastWeek,
    value: `${formatDate(addDays(new Date(), -7))}_${formatDate(new Date())}`,
    title: 'Last Week',
  },
  {
    id: CreatedAtFilterTypes.lastMonth,
    value: `${formatDate(addDays(new Date(), -30))}_${formatDate(new Date())}`,
    title: 'Last Month',
  },
  {
    id: 'custom-range',
    value: undefined,
    title: 'Custom range',
  },
]

const _CreatedAtFilter: FC<CreatedAtFilterProps> = props => {
  const { createdAt } = casesFiltersStore

  return (
    <CalendarContainer>
      <DatePickerField.Small
        placeholder="Created At"
        horizontalAlignment={HorizontalAlignment.Right}
        shouldDisplayInput={false}
        dateValue={createdAt ?? ''}
        shouldUseDatePickerBase
        shouldAcceptEmptyDate
        onChange={(value: string) => {
          props.onChange(value)
        }}
        minRangeLength={0}
        customDatePickerHeaderComponent={
          <CustomFilterDate>
            <ButtonGroup
              currentSelection={
                calendarOptions?.find(option => option.value === createdAt)?.value ?? undefined
              }
              name="date-picker-custom-filter-select-created-at-date"
              onClick={value => {
                props.onChange(value)
              }}
              options={calendarOptions}
            />
          </CustomFilterDate>
        }
      />
    </CalendarContainer>
  )
}

export const CreatedAtFilter = observer(_CreatedAtFilter)
